<div class="flex-cont" [ngClass]="{'flex-faqs': isNotProfile}">

  <div class="container" [ngClass]="{'not-profile': isNotProfile}">
    <div class="faqs-page" *ngIf="!loadingPage">

      <!-- Dentro del perfil el título va como el del resto de secciones; en la
           página pública se mantiene el de siempre. -->
      <p class="h2 faqs-title" *ngIf="isNotProfile">Preguntas frecuentes</p>
      <h2 class="section-title" *ngIf="!isNotProfile">Ayuda y preguntas frecuentes</h2>

      <div class="faqs-search">
        <i class="fa-light fa-magnifying-glass"></i>
        <input type="search"
               aria-label="Buscar en las preguntas frecuentes"
               placeholder="Buscar en las preguntas frecuentes"
               [ngModel]="search"
               (ngModelChange)="onSearch($event)">
      </div>

      <div class="faqs-accordion">
        <mat-accordion class="faq-item" multi>
          <mat-expansion-panel *ngFor="let faq of faqs"
            [ngClass]="isNotProfile ? 'mat-expansion' : 'mat-expansion-panel'">
            <mat-expansion-panel-header>
              <mat-panel-title>{{ faq.acf.question }}</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="faq-answer" [innerHTML]="faq.acf.descripcion"></div>
          </mat-expansion-panel>
        </mat-accordion>

        <div class="faqs-empty" *ngIf="search && !faqs.length">
          <i class="fa-light fa-magnifying-glass"></i>
          <p class="m-0">No hay ninguna pregunta que hable de «{{ search }}».</p>
          <button type="button" class="btn-link" (click)="clearSearch()">Ver todas las preguntas</button>
        </div>
      </div>

      <!-- Salida hacia una persona: si la respuesta no está aquí, que no se
           quede el usuario mirando la lista. -->
      <section class="faqs-contact" *ngIf="!isNotProfile">
        <span class="contact-icon"><i class="fa-light fa-comments"></i></span>
        <div class="contact-body">
          <h3 class="m-0 contact-title">¿No encuentras lo que buscas?</h3>
          <p class="m-0 contact-text">Escríbenos y te contestamos. Si es por un pedido concreto, dinos el número y
            vamos más rápido.</p>
        </div>
        <button type="button" class="btn-primary" (click)="goToContact()">Contactar</button>
      </section>
    </div>

    <div class="loading-container" *ngIf="loadingPage">
      <ng-lottie class="lottie" [options]="loadingLottie" containerClass="loading-box"></ng-lottie>
    </div>
  </div>
</div>
